import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

let searchData = {
    CompanyName: '',
    Mail: '',
    Phone: '',
    ClientType: '',
    PageNumber: 1,
    PageSize: 20
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"));
export const getClientManagementList = (item) => {
    let url = `${API.getClientList}?CompanyName=${item.CompanyName}&Mail=${item.Mail}&Phone=${item.Phone}&ClientType=${item.ClientType}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClientManagementListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClientManagementListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const getClientManagementDetails = (id) => {
    let url = `${API.getClientDetails}?clientId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClientDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClientDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getClientList = () => {
    let url = `${API.Clientlist}`;
    return dispatch =>{
    axios
      .get(url)
      .then((response) => {
        // this.state.clientList = response.data.clients;
        dispatch({type: "fetchClientList" ,data: response.data.clients})
        // this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
    }
  };


export const getClientUserDetails = (id) => {
    let url = `${API.getClientUsers}?clientId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                let fleetManager = response.data && response.data.filter(r => r.role === "fleetmanager");
                let techSuperintendent = response.data && response.data.filter(r => r.role === "superintendent");
                let techExecutive = response.data && response.data.filter(r => r.role === "technicalexecutive");
                dispatch({ type: "fleetManagerListSuccess", data: fleetManager });
                dispatch({ type: "techSuperintendentListSuccess", data: techSuperintendent });
                dispatch({ type: "techExecutiveListSuccess", data: techExecutive });
                dispatch({
                    type: "getClientUsersDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClientUsersDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postClientManagementDetails = (data) => {
    let url = `${API.getClientDetails}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                dispatch({
                    type: "postClientDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postClientDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postClientUserDetails = (data) => {
    const{t}=this.props;
    let url = `${API.postClientuser}`;
    return dispatch => {
        axios.post(url, data, {
            headers: {
                key: currentUser.accessToken
            }
        })
            .then((response) => {
                if (response.data !== "User Add Failed ") {
                    toast.success(t('CommonText.CommonAdd'), {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.props.history.goBack();
                }
                dispatch({
                    type: "postClientUserDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postClientUserDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putClientManagementDetails = (data) => {
    let url = `${API.getClientDetails}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch(getClientManagementList(searchData));
                dispatch({
                    type: "putClientDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putClientDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putClientUserDetails = (data) => {
    let url = `${API.postClientuser}`;
    return dispatch => {
        axios.put(url, data, {
            headers: {
                key: currentUser.accessToken
            }
        })
            .then((response) => {
                dispatch({
                    type: "putClientUserDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putClientUserDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteClientManagementDetails = (data) => {
    let url = `${API.getClientDetails}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "deleteClientDetailsSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteClientDetailsFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteClientUserDetails = (data) => {
    let url = `${API.postClientuser}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "deleteClientUserDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteClientUserDetailFailure",
                    error: "ERROR"
                })
            })
    }
}